import React, { useEffect, useState } from "react";
import queryString from "query-string";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import { auth } from "../../../utils/auth";
import { formatCurrency } from "../../../utils/helpers";
import { request } from "../../../utils/request";

dayjs.extend(duration);

const params = queryString.parse(window.location.search);

const Detalle = ({ proveedores, firma, sucursal, user }) => {
    return (
        <>
            <div className="row">
                <h2 className="col-md-12 text-center m-b-5">
                    Estado de Cuenta
                </h2>
                <div className="col-md-12 text-center">
                    {sucursal.nombre} - {sucursal.direccion} •{" "}
                    {params.desde && `Desde: ${dayjs(params.desde).format('DD/MM/YYYY')} - `} Hasta: ${dayjs(params.hasta).format('DD/MM/YYYY')}
                </div>
                <div className="col-md-12 text-center">
                    <small>Generado: {new Date().toLocaleString()} por {user.nombre} {user.apellido[0]}.</small>
                </div>
            </div>

            <div className="row p-b-10" style={{ fontSize: 'larger' }}>
                <div className="col-md-2">
                    Proveedores: {proveedores?.length}
                </div>

                <div className="col text-right">
                    <small>
                        <strong>DC:</strong> Días de Crédito |{" "}
                        <strong>DT:</strong> Días Transcurridos | {" "}
                        <strong>DV:</strong> Días Vencidos | {" "}
                        <strong>VD:</strong> Vendedor
                    </small>
                </div>
            </div>

            {proveedores?.filter(c => c.cuentas.length > 0).map(proveedor => {
                const recibosRegistrados = [];
                const cuentas = proveedor.cuentas.reduce((acc, cuenta) => {
                    if (cuenta.estado === 'cancelada' || (cuenta.recurrencia_id && cuenta.validada === 'no')) {
                        return acc;
                    }

                    const total = parseFloat(cuenta.total || 0);
                    const pagosTotal = (cuenta.pagos || []).reduce((sum, p) => sum + parseFloat(p.monto || 0), 0);
                    const pagado = cuenta.pagado != null ? parseFloat(cuenta.pagado) : pagosTotal;
                    const pendiente = total - pagado;

                    acc.push({
                        tipo: 'factura',
                        numero: cuenta.ncf || cuenta.numero || 'Sin número',
                        fecha: dayjs(cuenta.fecha),
                        monto: total,
                        recibido: pagado,
                        estado: cuenta.estado,
                        por_cobrar: pendiente,
                        pendiente: pendiente,
                        dc: cuenta.plazo?.dias ?? '',
                        dt: Math.abs(Math.round(dayjs.duration(dayjs(cuenta.fecha).diff(dayjs())).asDays())),
                        dv: (cuenta.estado === 'pagada' || (cuenta.fecha_vencimiento && dayjs(cuenta.fecha_vencimiento) > dayjs())) ? '0' : (cuenta.fecha_vencimiento ? Math.round(dayjs.duration(dayjs(cuenta.fecha_vencimiento).diff(dayjs())).asDays()) : ''),
                        vd: proveedor.detalles?.vendedor?.codigo ?? '',
                        afectada: '',
                    });

                    const alteraciones = [];

                    (cuenta.notas_credito || []).forEach(nota_credito => {
                        if (parseFloat(nota_credito.total || 0) > 0) {
                            alteraciones.push({
                                tipo: 'nota',
                                numero: nota_credito.numeracion,
                                fecha: dayjs(nota_credito.fecha),
                                monto: '',
                                por_cobrar: 0,
                                estado: nota_credito.estado,
                                recibido: nota_credito.estado == 'cancelada' ? 0 : parseFloat(nota_credito.total),
                                pendiente: 0,
                                dc: '',
                                dt: '',
                                dv: '',
                                vd: proveedor.detalles?.vendedor?.codigo ?? '',
                                afectada: cuenta.ncf || cuenta.numero || '',
                            });
                        }
                    });

                    (cuenta.pagos || []).forEach(pago => {
                        if (parseFloat(pago.monto || 0) > 0) {
                            const numero = 'Abono';
                            if (pago.monto < total) {
                                alteraciones.push({
                                    tipo: 'recibo',
                                    numero: numero,
                                    abonoTotal: '',
                                    fecha: dayjs(pago.fecha),
                                    monto: '',
                                    por_cobrar: 0,
                                    estado: '',
                                    recibido: parseFloat(pago.monto),
                                    pendiente: 0,
                                    dc: '',
                                    dt: '',
                                    dv: '',
                                    vd: proveedor.detalles?.vendedor?.codigo ?? '',
                                    afectada: cuenta.ncf || cuenta.numero || '',
                                });
                                if (!recibosRegistrados.includes(numero)) {
                                    recibosRegistrados.push(numero)
                                }
                            }
                        }
                    });

                    alteraciones.sort((a, b) => {
                        return a.fecha - b.fecha;
                    });

                    let bal = total;
                    alteraciones.forEach(a => {
                        bal -= a.recibido;
                        if (bal > 0 && !['cancelada', 'cancelado'].includes(a.estado)) {
                            a.pendiente = bal;
                        }
                        acc.push(a);
                    });

                    return acc;
                }, []);

                cuentas.sort((a, b) => {
                    return a.fecha - b.fecha;
                });

                let balance = 0;
                let balanceTotal = 0;
                let facturado = 0;
                let recibido = 0;

                cuentas.forEach(cuenta => {
                    if (cuenta.monto === cuenta.recibido) {
                        balanceTotal += 0;
                        balance += 0;
                    } else if (cuenta.recibido > 0) {
                        balanceTotal -= cuenta.recibido;
                        balance -= cuenta.recibido;
                    } else {
                        balanceTotal += cuenta.pendiente;
                        balance += cuenta.pendiente;
                    }
                    facturado += cuenta.monto ? cuenta.monto : 0;
                    recibido += cuenta.recibido;
                });

                return (
                    <>
                        <h4>PROVEEDOR: {proveedor.detalles.nombre}</h4>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td>RNC: {proveedor.detalles.identificacion}</td>
                                    <td className="text-right">Límite de Crédito Aprobado: {formatCurrency(proveedor.detalles.limite_credito)}</td>
                                </tr>
                                <tr>
                                    <td>Dirección: {proveedor.detalles.direccion}</td>
                                    <td className="text-right">Crédito Disponible: {formatCurrency((proveedor.detalles.credito_disponible || 0) - balanceTotal)}</td>
                                </tr>
                                <tr>
                                    <td>Teléfono: {proveedor.detalles.telefono}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="uppercase mt-2 text-center">
                            <strong className="mr-5">Total Facturado: {formatCurrency(facturado)}</strong>
                            <strong className="mr-5">Total Abonado: {formatCurrency(recibido)}</strong>
                            <strong>Balance: {formatCurrency(balance)}</strong>
                        </div>
                        <EstadoCuentaTable cuentas={cuentas} />
                    </>
                );
            })}
            {firma && <div className="footer-facturas">
                <div className="row justify-content-center mt-5">
                    <h3
                        className="col-10 col-md-3 text-center mr-md-2 mr-0 mt-md-4 fw-600 signature-title"
                        style={{ borderTop: "1px solid #000" }}
                    >
                        ELABORADO POR
                    </h3>
                    <div className="col-md-1 d-none d-md-block"></div>
                    <h3
                        className="col-10 col-md-3 text-center mr-md-2 mr-0 mt-md-4 fw-600 signature-title"
                        style={{ borderTop: "1px solid #000" }}
                    >
                        ENTREGADO POR
                    </h3>
                    <div className="col-md-1 d-none d-md-block"></div>
                    <h3
                        className="col-10 col-md-3 text-center ml-md-2 ml-0 fw-600 mt-5 mt-md-4 signature-title"
                        style={{ borderTop: "1px solid #000" }}
                    >
                        RECIBIDO POR
                    </h3>
                </div>
                <br /><br />
            </div>}
        </>
    );
};

const Resume = ({ proveedores, firma, sucursal, user }) => {
    const now = dayjs().format('DD/MM/YYYY hh:mm:ss a');

    return <>
        <div className="row">
            <small className="col-2">{now}</small>

            <h3 className="col-8 text-center m-b-5">
                {sucursal.nombre}
            </h3>

            <div className="col-2"></div>

            <div className="col-12 text-center fw-600 uppercase">
                Reporte de Estado de Cuenta x Proveedor
            </div>
            <div className="col-md-12 text-center">
                <strong>Desde:</strong> <span className="mr-4">{dayjs(params.desde).format('DD/MM/YYYY')}</span>

                <strong className="ml-4">Hasta:</strong> <span>{dayjs(params.hasta).format('DD/MM/YYYY')}</span>
            </div>
        </div>

        {proveedores?.filter(c => c.cuentas.length > 0).map(proveedor => {
            return <div className="my-2" key={`cl-${proveedor.id}`}>
                <div className="row" style={{ lineHeight: 1.2 }}>
                    <strong className="col-1">Proveedor:</strong>
                    <div className="col-10">{proveedor.detalles.nombre}</div>
                </div>

                <div className="row" style={{ lineHeight: 1.2 }}>
                    <strong className="col-1">Dirección:</strong>
                    <div className="col-10">{proveedor.detalles.direccion}</div>
                </div>

                <div className="row" style={{ lineHeight: 1.2 }}>
                    <strong className="col-1">Teléfono:</strong>
                    <div className="col-10">{proveedor.detalles.telefono}</div>
                </div>

                {!!proveedor.detalles?.vendedor && <div className="row" style={{ lineHeight: 1.2 }}>
                    <strong className="col-1">Vendedor:</strong>
                    <div className="col-10">{proveedor.detalles.vendedor.nombre} {proveedor.detalles.vendedor.apellido}</div>
                </div>}

                <table className="table mb-3">
                    <thead>
                        <tr style={{ borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                            <th>FECHA</th>
                            <th>NCF/NUMERO</th>
                            <th>IMPORTE</th>
                            <th>IMPUESTO</th>
                            <th>TOTAL</th>
                            <th>DEVOLUCIÓN</th>
                            <th>ABONO</th>
                            <th>NOTA CR</th>
                            <th>BALANCE</th>
                        </tr>
                    </thead>

                    <tbody>
                        {(proveedor.cuentas || []).filter(f => f.estado !== 'cancelada').map((cuenta) => {
                            const total = parseFloat(cuenta.total || 0);
                            const pagosTotal = (cuenta.pagos || []).reduce((sum, p) => sum + parseFloat(p.monto || 0), 0);
                            const pagado = cuenta.pagado != null ? parseFloat(cuenta.pagado) : pagosTotal;
                            const notasCreditoTotal = (cuenta.notas_credito || []).reduce((sum, nc) => sum + parseFloat(nc.total || 0), 0);
                            const detalleTotal = cuenta.detalle_total || {};
                            const subtotal = parseFloat(detalleTotal.subtotal || 0);
                            const impuestos = Object.entries(detalleTotal || {}).reduce((sum, [key, value]) => {
                                if (key !== 'subtotal') {
                                    return sum + parseFloat(value || 0);
                                }
                                return sum;
                            }, 0);

                            return <tr key={`c-${cuenta.id}`}>
                                <td>{dayjs(cuenta.fecha).format('DD/MM/YYYY')}</td>
                                <td>{cuenta.ncf || cuenta.numero || 'Sin número'}</td>
                                <td>{formatCurrency(subtotal)}</td>
                                <td>{formatCurrency(impuestos)}</td>
                                <td>{formatCurrency(total)}</td>
                                <td>{formatCurrency(0)}</td>
                                <td>{formatCurrency(pagado)}</td>
                                <td>{formatCurrency(notasCreditoTotal)}</td>
                                <td>{formatCurrency(total - pagado)}</td>
                            </tr>;
                        })}
                    </tbody>
                </table>
            </div>;
        })}

        {firma && <div className="footer-facturas">
            <div className="row justify-content-center mt-5">
                <h3
                    className="col-10 col-md-3 text-center mr-md-2 mr-0 mt-md-4 fw-600 signature-title"
                    style={{ borderTop: "1px solid #000" }}
                >
                    HECHO POR
                </h3>
                <div className="col-md-1 d-none d-md-block"></div>

                <h3
                    className="col-10 col-md-3 text-center ml-md-2 ml-0 fw-600 mt-5 mt-md-4 signature-title"
                    style={{ borderTop: "1px solid #000" }}
                >
                    AUTORIZADO POR
                </h3>
            </div>
            <br /><br />
        </div>}
    </>;
};

const PrintEstadosCuentaCXP = () => {
    const resume = params.tipo === 'resumen';
    const [proveedores, setProveedores] = useState([]);
    const [firma, setFirma] = useState(false);
    const [listo, setListo] = useState(false);

    const getCuentas = () => {
        request(
            "estados-de-cuentas-cxp" + window.location.search
        ).then((res) => {
            setProveedores(res.data?.cuentas);
            setListo(true);
        });
    };

    useEffect(() => {
        getCuentas();
    }, []);

    // Espera a que el estado con los datos ya esté reflejado en el DOM
    // antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (listo) {
            window.print();
        }
    }, [listo]);

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    return <>
        <style type="text/css" media="print">
            @page { "{ size: landscape; }" }
        </style>

        {
            resume
                ? <Resume proveedores={proveedores} firma={firma} sucursal={sucursal} user={user} />
                : <Detalle proveedores={proveedores} firma={firma} sucursal={sucursal} user={user} />
        }

        <div className="ordernar-resultados no-print">
            <div className="form-group">
                <div className="radio-btn">
                    <label>
                        <input
                            type="radio"
                            onChange={() => setFirma(false)}
                            name="orden"
                            value={false}
                            defaultChecked={true}
                        />{" "}
                        Sin líneas de firma
                    </label>
                    <label>
                        <input
                            type="radio"
                            onChange={() => setFirma(true)}
                            name="orden"
                            value={true}
                        />{" "}
                        Con líneas de firma
                    </label>
                </div>
            </div>
        </div>
    </>;
};

const EstadoCuentaTable = ({ cuentas }) => {
    let balance = 0;

    return (
        <table className="table m-b-40 m-t-15">
            <thead>
                <tr>
                    <th>Documento</th>
                    <th>Fecha</th>
                    <th>DC</th>
                    <th>DT</th>
                    <th>DV</th>
                    <th>VD</th>
                    <th>Estado</th>
                    <th>Afectada</th>
                    <th className="text-right">Facturado</th>
                    <th className="text-right">Abono</th>
                    <th className="text-right">Pendiente</th>
                    <th className="text-right">Balance</th>
                </tr>
            </thead>
            <tbody>
                {cuentas.map((cuenta) => {
                    if (cuenta.monto === cuenta.recibido) {
                        balance += 0;
                    } else if (cuenta.recibido > 0) {
                        balance -= cuenta.recibido;
                    } else {
                        balance += cuenta.pendiente;
                    }

                    const balanceActual = balance;

                    return (
                        <tr key={cuenta.numero + cuenta.fecha.format('DD/MM/YYYY')}>
                            <td>{cuenta.numero}</td>
                            <td>{cuenta.fecha.format('DD/MM/YYYY')}</td>
                            <td>{cuenta.dc}</td>
                            <td>{cuenta.dt}</td>
                            <td>{cuenta.dv}</td>
                            <td>{cuenta.vd}</td>
                            <td>{cuenta.estado}</td>
                            <td>{cuenta.afectada}</td>
                            <td className="text-right">{cuenta.monto > 0 && formatCurrency(cuenta.monto)}</td>
                            <td className="text-right">{cuenta.recibido > 0 && formatCurrency(cuenta.recibido)}</td>
                            <td className="text-right">{formatCurrency(cuenta.pendiente)}</td>
                            <td className="text-right">{formatCurrency(balanceActual)}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default PrintEstadosCuentaCXP;
